export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/feedback.6184ceca.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};